import { render } from "./CreateTeamSuccessPage.vue?vue&type=template&id=3a1f5a41"
import script from "./CreateTeamSuccessPage.vue?vue&type=script&lang=js"
export * from "./CreateTeamSuccessPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__